// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetUsersRequestModel from '../../model/get-users-request-model';
import GetUsersRequestDTO from '../dto/get-users-request-dto';

export default abstract class GetUsersRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetUsersRequestDTO>) {
    super();
    if (data) {
      this.searchCriteria = data.searchCriteria;
      this.statusId = data.statusId;
      this['paging.CurrentPage'] = data['paging.CurrentPage'];
      this['paging.PageSize'] = data['paging.PageSize'];
      this['paging.IncludeCount'] = data['paging.IncludeCount'];
      this['paging.NoPaging'] = data['paging.NoPaging'];
    }
  }
  /**
  */
  'searchCriteria'?: string;
  /**
  * @type {int32}
  */
  'statusId'?: number;
  /**
  * @type {int32}
  */
  'paging.CurrentPage'?: number;
  /**
  * @type {int32}
  */
  'paging.PageSize'?: number;
  /**
  */
  'paging.IncludeCount'?: boolean;
  /**
  */
  'paging.NoPaging'?: boolean;

  static toModel(dto: DeepPartial<GetUsersRequestDTO>): GetUsersRequestModel;
  static toModel(dto: DeepPartial<GetUsersRequestDTO> | undefined | null): GetUsersRequestModel | undefined;
  static toModel(dto: DeepPartial<GetUsersRequestDTO> | undefined | null): GetUsersRequestModel | undefined {
    return dto ? new GetUsersRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetUsersRequestModel> | GetUsersRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'searchCriteria': unwrapped.searchCriteria,
      'statusId': unwrapped.statusId,
      'paging.CurrentPage': unwrapped['paging.CurrentPage'],
      'paging.PageSize': unwrapped['paging.PageSize'],
      'paging.IncludeCount': unwrapped['paging.IncludeCount'],
      'paging.NoPaging': unwrapped['paging.NoPaging'],
    } as GetUsersRequestDTO;
  }
}
